import React, { useMemo } from 'react';
import Picker from 'react-mobile-picker';
import {
  MobileContainer,
  MobileTopRow,
  MobileLabel,
  ValueText,
  ValueTextLabel,
  DropdownArrow,
  StyledPickerWrapper,
} from './styles';

const createOptionsFromEnum = (
  customEnum,
  customEnumVisibility,
  currentValue
) => {
  if (!customEnum) {
    return [];
  }
  const allItems = Object.entries(customEnum).map(([value, label]) => ({
    value,
    label,
  }));
  if (!customEnumVisibility) {
    return allItems;
  }
  const filteredItems = allItems.filter(
    (item) => customEnumVisibility[item.value] !== false
  );
  if (
    currentValue &&
    !filteredItems.find((item) => item.value == currentValue)
  ) {
    filteredItems.unshift({
      value: currentValue,
      label: customEnum[currentValue] || currentValue,
      disabled: true,
    });
  }
  return filteredItems;
};

const ListControl = ({
  pointId,
  currentValue,
  config = {},
  label,
  isEditable,
  handleValueChange,
  controlType,
  activePickerId,
  onPickerToggle,
}) => {
  const isPickerOpen = activePickerId === pointId;
  const isToggle = controlType === 'toggle';
  const { customEnum, customEnumVisibility } = config;

  const defaultToggleOptions = useMemo(
    () => [
      { value: 0, label: 'Off' },
      { value: 1, label: 'On' },
    ],
    []
  );

  const selectOptions = useMemo(() => {
    const baseOptions = isToggle
      ? customEnum && Object.keys(customEnum).length > 0
        ? createOptionsFromEnum(customEnum, customEnumVisibility, currentValue)
        : defaultToggleOptions
      : createOptionsFromEnum(customEnum, customEnumVisibility, currentValue);

    return baseOptions.map((option) => ({
      id: option.value,
      name: option.label,
      disabled: option.disabled,
    }));
  }, [
    isToggle,
    customEnum,
    defaultToggleOptions,
    customEnumVisibility,
    currentValue,
  ]);

  const pickerNames = useMemo(
    () => selectOptions.filter((o) => !o.disabled).map((o) => o.name),
    [selectOptions]
  );

  const displayValue = useMemo(() => {
    const option = selectOptions.find((opt) => opt.id == currentValue);
    if (option) {
      return option.name;
    }
    if (isToggle) {
      return currentValue ? 'On' : 'Off';
    }
    return customEnum?.[currentValue] || currentValue || '--';
  }, [selectOptions, currentValue, isToggle, customEnum]);

  const selectedName = useMemo(() => {
    const option = selectOptions.find((opt) => opt.id == currentValue);
    return option ? option.name : pickerNames[0] || '';
  }, [selectOptions, currentValue, pickerNames]);

  const handlePickerChange = (_, name) => {
    const option = selectOptions.find((opt) => opt.name === name);
    if (option) {
      handleValueChange(pointId, option.id);
    }
  };

  return (
    <MobileContainer isEditable={isEditable}>
      <MobileTopRow
        onClick={() => isEditable && onPickerToggle(pointId)}
      >
        <MobileLabel>{label}</MobileLabel>
        <ValueText>
          <ValueTextLabel>{displayValue}</ValueTextLabel>
          <DropdownArrow />
        </ValueText>
      </MobileTopRow>
      {isPickerOpen && isEditable && (
        <StyledPickerWrapper>
          <Picker
            optionGroups={{ value: pickerNames }}
            valueGroups={{ value: selectedName }}
            onChange={handlePickerChange}
            wheel="normal"
            height={150}
            itemHeight={30}
          />
        </StyledPickerWrapper>
      )}
    </MobileContainer>
  );
};

export default ListControl;
